import { HashRouter, Routes, Route } from 'react-router-dom'
import Layout from './shared/components/Layout'
import ScholarshipsPage from './pages/ScholarshipsPage'
import ExtensionInfoPage from './pages/ExtensionInfoPage'

export default function App() {
  return (
      <HashRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<ScholarshipsPage />} />
            <Route path="/extension-info" element={<ExtensionInfoPage/>} />
          </Routes>
        </Layout>
      </HashRouter>
  )
}